







































import Vue from 'vue'
import { UiColorSettingName, standardizeHexColorCasing } from '@/app/uiSettings/uiSettings'

export default Vue.extend({
  name: 'TedsLauncherUpdateColors',
  data() {
    return {
      state: {
        /** Whether the upload is in progress or not */
        attemptingUpload: false,
      },
    }
  },
  computed: {
    /** Text for the "save" button depending on if the upload is in progress or not */
    saveLogoButtonText(): string {
      return this.state.attemptingUpload ? 'Saving ...' : 'Save Colors'
    },
  },
  methods: {
    /** Propagate state of newly selected color */
    colorSelected(settingName: UiColorSettingName, hexValue: string) {
      this.$launcher.uiSettings.stageChange(settingName, standardizeHexColorCasing(hexValue))
    },
    /** Upload the new logo */
    async uploadNewColors() {
      // If we're already uploading then just display a message
      if (this.state.attemptingUpload) {
        this.$launcher.bootState.tedsUi.notifications.error(`Upload in progress, please wait.`)
      }
      // Else upload new logo
      else {
        try {
          this.state.attemptingUpload = true
          if (this.$launcher.uiSettings.isChangeStagedFor('primaryColor')) {
            await this.$launcher.uiSettings.updateColor('primaryColor')
          }
          if (this.$launcher.uiSettings.isChangeStagedFor('backgroundFontColor')) {
            await this.$launcher.uiSettings.updateColor('backgroundFontColor')
          }
        } finally {
          this.state.attemptingUpload = false
        }
      }
    },
    /** Remove the new select logo, unless upload has already started */
    rollbackStagedColorsIfAny() {
      // If we're already uploading then just display a message
      if (this.state.attemptingUpload) {
        this.$launcher.bootState.tedsUi.notifications.error(`Upload in progress, please wait.`)
      } else {
        this.$launcher.uiSettings.rollbackStagedColorChangesIfAny()
      }
    },
  },
})
